module.exports = __webpack_public_path__ + "static/media/mjumbe.46b74517.jpg";